/* import __COLOCATED_TEMPLATE__ from './project-version-list.hbs'; */
import Component from '@glimmer/component';
import { sort } from '@ember/object/computed';

export default class ProjectVersionListComponent extends Component {
  versionSorting = ['versionNumber:desc'];
  @sort('args.projectVersions', 'versionSorting') sortedProjectVersions;
}
